import { useState, useEffect } from 'react';

/** Alinhado ao MapPage: alta precisão, timeout maior no primeiro fix. */
export const GEOLOCATION_OPTIONS: PositionOptions = {
    enableHighAccuracy: true,
    maximumAge: 5_000,
    timeout: 25_000,
};

export type UserGeoFix = { lat: number; lng: number; accuracyM: number };

/**
 * Posição atual do usuário (watch). Retorna null se API indisponível ou permissão negada.
 */
export function useUserGeolocation(): UserGeoFix | null {
    const [fix, setFix] = useState<UserGeoFix | null>(null);

    useEffect(() => {
        if (!navigator.geolocation) return;

        const onOk = (pos: GeolocationPosition) => {
            const { latitude, longitude, accuracy } = pos.coords;
            const accuracyM = Math.min(Math.max(accuracy || 35, 12), 500);
            setFix({ lat: latitude, lng: longitude, accuracyM });
        };

        const watchId = navigator.geolocation.watchPosition(onOk, () => {}, GEOLOCATION_OPTIONS);
        return () => navigator.geolocation.clearWatch(watchId);
    }, []);

    return fix;
}
